import { render, staticRenderFns } from "./ProgrammaticDataDetail.vue?vue&type=template&id=1d1fabc4&scoped=true&"
import script from "./ProgrammaticDataDetail.vue?vue&type=script&lang=ts&"
export * from "./ProgrammaticDataDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1fabc4",
  null
  
)

export default component.exports